import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { querySaga } from '../../../utils/reduxHelper';

function* resetDashboardStatsSaga() {
    yield put(appActions.DASHBOARD_RESET_SUCCESS());
}

function* watchDashboardStatsGetStatsRequest() {
    yield takeLatest(
        appActions.DASHBOARD_GET_STATS_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                'integration/file/file-stats',
                appActions.DASHBOARD_GET_STATS_SUCCESS,
                appActions.DASHBOARD_GET_STATS_FAILURE,
            );
        },
    );
}

function* watchDashboardStatsGetPjoStatsRequest() {
    yield takeLatest(
        appActions.DASHBOARD_GET_PJO_STATS_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                'integration/file/pjo-stats',
                appActions.DASHBOARD_GET_PJO_STATS_SUCCESS,
                appActions.DASHBOARD_GET_PJO_STATS_FAILURE,
            );
        },
    );
}

export default function* dashboardStatsWatcher() {
    yield* watchDashboardStatsGetStatsRequest();
    yield* watchDashboardStatsGetPjoStatsRequest();
    yield takeLatest(appActions.DASHBOARD_RESET_REQUEST.type, resetDashboardStatsSaga);
}